import React, { useState } from 'react';
import Button from '../button';
import CopyToClipboardIcon from './CopyToClipboardIcon';
import { Container, OffsetContainer } from './styles';

const CopyToClipboard: React.FC<{
  string?: string;
  children?: React.ReactNode;
  variant?: 'button';
}> = ({ string, children, variant }) => {
  const [clipboard, setClipboard] = useState(false);
  const [className, setClassName] = useState('copied-0');
  let timeout: NodeJS.Timeout;

  function copyToClipboard(str) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard
        .writeText(str)
        .then(() => {
          console.log('Text copied to clipboard');
        })
        .catch((err) => {
          console.error('Failed to copy text: ', err);
        });
    } else {
      // Fallback 方案
      const textArea = document.createElement('textarea');
      textArea.value = str;
      // 使 textArea 不可见
      textArea.style.position = 'fixed';
      textArea.style.left = '-999999px';
      textArea.style.top = '-999999px';
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();

      return new Promise((res, rej) => {
        // 对于旧版浏览器
        try {
          document.execCommand('copy');
          console.log('Text copied to clipboard');
          document.body.removeChild(textArea);
          res(true);
        } catch (err) {
          console.error('Failed to copy text: ', err);
          document.body.removeChild(textArea);
          rej(err);
        }
      });
    }
  }

  const onCopy = () => {
    if (!string) return;
    const str = string.trim();
    copyToClipboard(str);
    setClipboard(true);
    setClassName('copied');
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      setClipboard(false);
      setClassName('copied-0');
    }, 1000);
  };

  if (variant === 'button')
    return (
      <Button disabled={!string} onClick={onCopy} className={className}>
        <div
          style={{
            display: 'flex',
            gap: '8px',
            alignItems: 'center',
            overflow: 'hidden',
          }}
        >
          <div
            style={{
              width: '16px',
            }}
          >
            <CopyToClipboardIcon copied={clipboard} />
          </div>
          {children}
        </div>
      </Button>
    );

  return (
    <Container onClick={onCopy} $disabled={!string} className={className}>
      <OffsetContainer>
        {children as any}
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            overflow: 'hidden',
          }}
        >
          <CopyToClipboardIcon copied={clipboard} small />
        </div>
      </OffsetContainer>
    </Container>
  );
};

export default CopyToClipboard;
